var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 167,
    viewBox: "0 0 158 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 25.7499C60.3357 25.7499 25.7497 60.3359 25.7497 103C25.7497 145.664 60.3357 180.25 103 180.25C145.664 180.25 180.25 145.664 180.25 103C180.25 60.3359 145.664 25.7499 103 25.7499ZM8.58301 103C8.58301 50.855 50.8548 8.58325 103 8.58325C155.145 8.58325 197.416 50.855 197.416 103C197.416 155.145 155.145 197.417 103 197.417C50.8548 197.417 8.58301 155.145 8.58301 103Z",
    fill: "#E8E0EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 60.0833C107.741 60.0833 111.584 63.9261 111.584 68.6666V137.333C111.584 142.074 107.741 145.917 103 145.917C98.2599 145.917 94.417 142.074 94.417 137.333V68.6666C94.417 63.9261 98.2599 60.0833 103 60.0833Z",
    fill: "#E8E0EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.083 103C60.083 98.2596 63.9259 94.4167 68.6663 94.4167H137.333C142.073 94.4167 145.916 98.2596 145.916 103C145.916 107.741 142.073 111.583 137.333 111.583H68.6663C63.9259 111.583 60.083 107.741 60.083 103Z",
    fill: "#E8E0EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.c98d9e656910d740d260783d26aef389.svg";
export { ForwardRef as ReactComponent };